/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { motion } from 'framer-motion'

const PageTransition = ({ children }) => (
  <motion.div
    initial={{ marginLeft: '25px', opacity: 0 }}
    animate={{ marginLeft: 0, opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.1, type: 'spring' }}
  >
    {children}
  </motion.div>
)

export default PageTransition
